// FAQ – editierbar. Keine Angaben zu Haustieren, Rauchen, Storno, Check-in, Frühstück oder Zahlung, bis bestätigt.
import type { Localized } from "./site";

export type FaqItem = { id: string; question: Localized; answer: Localized };

export const faqItems: FaqItem[] = [
  {
    id: "preis",
    question: { de: "Wie viel kostet eine Übernachtung?", en: "How much does a night cost?" },
    answer: {
      de: "Die aktuelle Preisangabe beginnt bei 20 € pro Bett und Nacht. Für aktuelle Preise und Verfügbarkeiten kontaktieren Sie uns bitte oder prüfen Sie die Buchungsmöglichkeiten.",
      en: "The current rate starts at €20 per bed per night. For current prices and availability, please contact us or check the booking options.",
    },
  },
  {
    id: "betten",
    question: { de: "Welche Betten gibt es?", en: "What kind of beds are there?" },
    answer: { de: "Alle Zimmer verfügen über Einzelbetten.", en: "All rooms have single beds." },
  },
  {
    id: "kueche",
    question: { de: "Gibt es eine Gemeinschaftsküche?", en: "Is there a shared kitchen?" },
    answer: {
      de: "Ja, eine voll ausgestattete Gemeinschaftsküche ist vorhanden – es ist alles da (Herd, Backofen, Kühlschrank, Mikrowelle, Geschirr und Kaffeemaschine).",
      en: "Yes, a fully equipped shared kitchen is available – everything is there (stove, oven, fridge, microwave, dishes and coffee machine).",
    },
  },
  {
    id: "kosten",
    question: { de: "Gibt es zusätzliche Kosten?", en: "Are there any extra costs?" },
    answer: {
      de: "Nein, es gibt keine zusätzlichen Kosten. WLAN, Parkplatz und die Nutzung der Gemeinschaftsküche sind inklusive.",
      en: "No, there are no extra costs. Wi-Fi, parking and use of the shared kitchen are included.",
    },
  },
  {
    id: "reinigung",
    question: { de: "Wie oft wird gereinigt?", en: "How often is cleaning done?" },
    answer: {
      de: "Wir reinigen selbst 2× pro Woche – inklusive Bettwäsche.",
      en: "We clean ourselves twice a week – bed linen included.",
    },
  },
  {
    id: "checkout",
    question: { de: "Wann ist Check-out?", en: "When is check-out?" },
    answer: {
      de: "Der Check-out ist jederzeit möglich – ganz flexibel nach Ihrem Aufenthalt.",
      en: "Check-out is possible at any time – completely flexible after your stay.",
    },
  },
  {
    id: "parken",
    question: { de: "Gibt es Parkplätze?", en: "Is there parking?" },
    answer: {
      de: "Ja, es stehen 20 private Parkplätze direkt am Haus zur Verfügung – kostenlos.",
      en: "Yes, 20 private parking spaces are available right at the property – free of charge.",
    },
  },
  {
    id: "wlan",
    question: { de: "Gibt es WLAN?", en: "Is there Wi-Fi?" },
    answer: { de: "Ja, kostenloses WLAN ist vorhanden.", en: "Yes, free Wi-Fi is available." },
  },
  {
    id: "bad",
    question: { de: "Gibt es Badezimmer im Zimmer?", en: "Do rooms have private bathrooms?" },
    answer: {
      de: "Die Badezimmer und sanitären Einrichtungen werden gemeinschaftlich genutzt.",
      en: "Bathrooms and sanitary facilities are shared.",
    },
  },
  {
    id: "zielgruppe",
    question: { de: "Für wen ist die Unterkunft geeignet?", en: "Who is the accommodation suitable for?" },
    answer: {
      de: "Die Unterkunft eignet sich insbesondere für Monteure, Geschäftsreisende, Arbeiter, Gruppen und Gäste, die eine praktische Unterkunft in Königsbrunn suchen.",
      en: "The accommodation is particularly suitable for contractors, business travellers, workers, groups and guests looking for practical lodging in Königsbrunn.",
    },
  },
  {
    id: "booking",
    question: { de: "Kann ich über Booking.com buchen?", en: "Can I book via Booking.com?" },
    answer: {
      de: "Ja. Sie können direkt über Booking.com buchen – nutzen Sie dazu den Button „Verfügbarkeit prüfen“.",
      en: "Yes. You can book directly via Booking.com – just use the “Check availability” button.",
    },
  },
];
